export class DocumentCreateButtonInfo {
  constructor(
    public buttonName: string,
    public formatOriginalId: number,
  ) {
  }
}
